"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _julia = _interopRequireDefault(require("refractor/lang/julia.js"));

;
var _default = _julia["default"];
exports["default"] = _default;